import flagGermany from '@shared/assets/icons/flag-germany.svg';
import flagItaly from '@shared/assets/icons/flag-italy.svg';
import flagSpain from '@shared/assets/icons/flag-spain.svg';
import flagUnitedKingdom from '@shared/assets/icons/flag-unitedKingdom.svg';
import { AppLanguageCountryCode, AppLanguageCountryCodes, AppLanguageLocales } from '@shared/types/countryCodes.ts';

export interface Language {
  name: string;
  code: AppLanguageCountryCode;
  locale: string;
  flagIcon: string;
}

const languages = [
  {
    name: `Italian`,
    code: AppLanguageCountryCodes.IT,
    locale: AppLanguageLocales[AppLanguageCountryCodes.IT],
    flagIcon: flagItaly,
  },
  {
    name: `English`,
    code: AppLanguageCountryCodes.EN,
    locale: AppLanguageLocales[AppLanguageCountryCodes.EN],
    flagIcon: flagUnitedKingdom,
  },
  {
    name: `Spanish`,
    code: AppLanguageCountryCodes.ES,
    locale: AppLanguageLocales[AppLanguageCountryCodes.ES],
    flagIcon: flagSpain,
  },
  {
    name: `German`,
    code: AppLanguageCountryCodes.DE,
    locale: AppLanguageLocales[AppLanguageCountryCodes.DE],
    flagIcon: flagGermany,
  },
];

export { languages };
